module.exports = __webpack_public_path__ + "static/media/google_play_en.468ef7f5.png";